import React, { useContext, useEffect, useState } from 'react'
import { BrowserRouter as Router } from 'react-router-dom'

import { KeycloakOauth2Provider } from 'contexts/KeycloakOauth2Context'
import { HistoryProvider } from 'contexts/HistoryContext'
import { WebSocketContext, WebSocketProvider } from 'contexts/WebSocketProvider'
import { PatientLockEditProvider } from 'contexts/PatientLockEditProvider'
//import { JWTProvider } from "./contexts/JWTContext";
//import { Auth0Provider } from "./contexts/Auth0Context";
import routes, { renderRoutes } from './routes'
import { BASENAME } from './config/constant'
import * as serviceWorkerRegistration from './serviceWorkerRegistration'
import axios from 'axios'
import Swal from 'sweetalert2';
import SplashScreen from 'views/splash-screen'
import IdleScreen from 'views/maintenance/IdleScreen'
import { clearAllCache } from 'utility/httpClient.util'

const CACHE_CLEAR_ROOM = 'ckd-cache-clear'
const CACHE_CLEAR_EVENT = 'cache-clear'

const CacheClearBroadcastListener = () => {
  const { socket, subscribe, unsubscribe } = useContext(WebSocketContext) || {}

  useEffect(() => {
    if (!socket || !socket.connect || !subscribe) return

    const handleCacheClear = () => {
      clearAllCache(
        () => console.log('API cache cleared by broadcast'),
        () => console.log('Unable to clear API cache by broadcast'),
      )
    }

    const channel = subscribe(CACHE_CLEAR_ROOM)
    channel.bind(CACHE_CLEAR_EVENT, handleCacheClear)

    return () => {
      if (unsubscribe) {
        unsubscribe(CACHE_CLEAR_ROOM)
      }
    }
  }, [socket])

  return null
}

const App = () => {
  const [newVersionAvailable, setNewVersionAvailable] = useState(false)
  const [version, setVersion] = useState(
    localStorage.getItem('ckdoctor_build_version') || '',
  )

  // useEffect(() => {
  //   // Register the service worker as usual
  //   serviceWorkerRegistration.register({
  //     onUpdate: async (registration) => {
  //       // This callback will be called when a new service worker is ready to take control
  //       // Define an async function to fetch and process the manifest
  //       const updateVersion = async () => {
  //         try {
  //           const timestamp = Date.now()
  //           const response = await axios.get(`./manifest.json?v=${timestamp}`)
  //           const result = response.data
  //           localStorage.setItem('ckdoctor_build_version', result.version)
  //           setVersion(result.version)
  //         } catch (error) {
  //           console.error('Error fetching the manifest:', error)
  //         }
  //       }

  //       // Call the async function
  //       await updateVersion()
  //       setNewVersionAvailable(true)
  //     },
  //     onSuccess: async (registration)=>{
  //       Swal.fire({
  //         title: 'Offline Available',
  //         text: 'Content is cached for offline use.',
  //         icon: 'info',
  //         showCancelButton: false,
  //         confirmButtonColor: '#3085d6',
  //         cancelButtonColor: '#d33',
  //         confirmButtonText: 'Ok'
  //       }).then((result) => {

  //       });
  //     }
  //   })
  // }, [])

  const getSubpath = () => {
    const pathname = window.location.pathname;
    // Assuming your app is deployed at a subpath like /app or /his
    const subpath = pathname.split('/')[1];
    return subpath ? `/${subpath}` : '';
};

  useEffect(() => {
    const handleUpdate = () => {
      const updateVersion = async () => {
        try {
          const subpath = getSubpath();
          const timestamp = Date.now();
          const formattedSubpath = subpath.endsWith('/') ? subpath : `${subpath}/`;
          const response = await axios.get(`${formattedSubpath}manifest.json?v=${timestamp}`); 
          const result = response.data;
          localStorage.setItem('ckdoctor_build_version', result.version);
          // Assuming setVersion is defined elsewhere in your context or state
          setVersion(result.version);
          setNewVersionAvailable(true);
        } catch (error) {
          console.error('Error fetching the manifest:', error);
        }
      };
      
      updateVersion().then(() => {
        // Handle new version available logic
        //setNewVersionAvailable(true);
      });
    };

    const handleSuccess = () => {
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Content is cached for offline use.",
          showConfirmButton: false,
          timer: 1500
        });
    };

    // Listen to custom event fired when service worker updates
    document.addEventListener('serviceWorkerUpdated', handleUpdate, { once: true });
    document.addEventListener('serviceWorkerSuccess', handleSuccess, { once: true });

    // Cleanup
    return () => {
      document.removeEventListener('serviceWorkerUpdated', handleUpdate);
      document.removeEventListener('serviceWorkerSuccess', handleSuccess);
    };
  }, []);


  useEffect(() => {
    if (newVersionAvailable) {
      Swal.fire({
        title: 'New version available!',
        text: 'Update the app to the latest version.',
        icon: 'info',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Reload'
      }).then((result) => {
        if (result.isConfirmed) {
          //window.location.reload();
          updateServiceWorker();
        }
      });
    }
  }, [newVersionAvailable])

  

  const updateServiceWorker = () => {
    navigator.serviceWorker.getRegistration().then(registration => {
      if (registration.waiting) {
        // Tell the waiting service worker to skipWaiting
        registration.waiting.postMessage({ type: 'SKIP_WAITING' });
      }
    });
  

    // Reload the page to let the new service worker take control
    window.location.reload();
  };


  const reload = () => {
    console.log('reloading...')
    serviceWorkerRegistration.unregister(() => {
      serviceWorkerRegistration.register()
      window.location.reload()
    })
  }

  const updateServiceWorker2 = () => {
    // This will tell the new service worker to take control immediately
    if (navigator.serviceWorker && navigator.serviceWorker.controller) {
      navigator.serviceWorker.controller.postMessage({ type: 'SKIP_WAITING' });
    }
    // Reload the page to let the new service worker take control
    window.location.reload()
  }

  return (
    <React.Fragment>
      <Router basename={BASENAME}>
        <HistoryProvider>          
          <KeycloakOauth2Provider>
            <PatientLockEditProvider>
              <SplashScreen />
              <IdleScreen />
              <WebSocketProvider>
                <CacheClearBroadcastListener />
                {renderRoutes(routes)}
              </WebSocketProvider> 
            </PatientLockEditProvider>
          </KeycloakOauth2Provider>                             
        </HistoryProvider>
      </Router>
      
    </React.Fragment>
  )
}

export default App
